module.exports = __webpack_public_path__ + "static/media/settings.f1e6dad3.svg";